/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import Error500Dumb from './Error500Dumb';
import { isErrorReportingEnabled } from 'src/shared/app/base/selector/appEnvSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  sentryId: ?string,
  error: Error,
  errorInfo: Object,
};

const mapStateToProps = (
  state: State,
  { sentryId, error, errorInfo }: Props,
): Object => ({
  sentryId,
  error,
  errorInfo,
  isErrorReportingEnabled: isErrorReportingEnabled(state),
});

export default compose(connect(mapStateToProps))(Error500Dumb);
